var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.75 7.16 3.09 3.09M5.293 15.619 15.619 5.293a1 1 0 0 1 1.413 0l1.676 1.676a1 1 0 0 1 0 1.413L8.381 18.707a.995.995 0 0 1-.706.293H5v-2.675c0-.265.105-.519.293-.706Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;